// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8cf1b645","150":"168096a2","239":"82a25cc5","454":"d1024847","467":"09647de0","538":"f4546d98"}[chunkId] + ".chunk.js";
};